<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!modoAprovacao">
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Abertura</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Valor</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="setAprovacao(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char40">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.orcamento_valor) }}</td>
                </tr></tbody>
            </table></div>


            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
        <div v-else>
            <EmptyStateComponent
                title="Nenhum Orçamento aguardando aprovação"
                message="Todas os orçamentos lançados já foram aprovados ou reprovados."
            />
        </div>

            
        <div class="row-space"></div>
        <div class="row-end">
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="modoAprovacao && objEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item info-card">
                    <span>Dados</span>
                    <strong>OS {{ Funcoes.formatInteger(objEdicao.cdos) }} - {{ objEdicao.nmos }}</strong>
                </div>
                
                <div class="form-item info-card">
                    <span>Equipamento/Veículo</span>
                    <strong>{{ objEdicao.nmequipamento }} · Placa {{ objEdicao.placa }}</strong>
                </div>
            
                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Data Orçamento</span>
                    <strong class="center">{{ Funcoes.formatDateFromJson(objEdicao.dtabertura) }}</strong>
                </div>
            </div>
            
            <div class="row">
                <div class="form-item info-card">
                    <span>Fornecedor</span>
                    <strong>{{ objEdicao.nmfornecedor }}</strong>
                </div>
            
                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Valor Orçamento</span>
                    <strong class="right">R$ {{ Funcoes.formatDecimal(objEdicao.orcamento_valor) }}</strong>
                </div>
            </div>
        </div>

        <div class="table-wrapper row-space">
            <table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Descrição</th>
                        <th>Qtd.</th>
                        <th>Vl. Unit.</th>
                        <th>Vl. Líquido</th>
                        <th>Licitação</th>
                        <th>% Desc.</th>
                        <th>Vl. Desc.</th>
                        <th>Vl. Autorizado</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="(item, index) in lsItens"
                        :key="item.id"
                        :class="{
                            'even-row': index % 2 === 0,
                            'odd-row': index % 2 !== 0
                        }"
                    >
                        <td class="col-width-char6 right">
                            {{ Funcoes.formatInteger(item.ordem) }}
                        </td>

                        <td>{{ item.descricao }}</td>

                        <td class="col-width-char05 right">
                            {{ Funcoes.formatDecimal(item.qtdd) }}
                        </td>

                        <td class="col-width-char10 right">
                            {{ Funcoes.formatDecimal(item.vlunitario) }}
                        </td>

                        <td class="col-width-char10 right">
                            {{ Funcoes.formatDecimal(item.vlliquido) }}
                        </td>

                        <td class="col-width-char25">
                            <select
                                v-model.number="item.aut_idlicitacao"
                                class="input-full"
                                @change="aplicarLicitacaoItem(item)"
                            >
                                <option :value="null">Sem licitação</option>
                                <option
                                    v-for="lic in lsLicitacoes"
                                    :key="lic.id"
                                    :value="lic.id"
                                >
                                    {{ lic.nrlicitacao }} - {{ Funcoes.formatDecimal(lic.aldesconto) }}%
                                </option>
                            </select>
                        </td>

                        <td class="col-width-char10 right">
                            {{ Funcoes.formatDecimal(item.aut_aldesconto) }}
                        </td>

                        <td class="col-width-char15 right">
                            {{ Funcoes.formatDecimal(item.aut_vldesconto) }}
                        </td>

                        <td class="col-width-char15 right">
                            {{ Funcoes.formatDecimal(item.aut_vlautorizado) }}
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="4" class="right"><strong>Totais</strong></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalLiquido) }}</strong></td>
                        <td colspan="2"></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalDesconto) }}</strong></td>
                        <td class="right"><strong>{{ Funcoes.formatDecimal(totalAutorizado) }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="abrirModalAprovar">APROVAR</button>
            <button class="btn-cancel" @click="abrirModalDesaprovar">NÃO APROVAR</button>
            <button @click="baixarAnexo(objEdicao.orcamento_idanexo)">VER ANEXO</button>
            <button @click="modoAprovacao=false">VOLTAR</button>
        </div>
    </div>

    <ConfirmModal ref="confirmAprovar" />
    <ConfirmModal ref="confirmDesaprovar" />
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';

const emit = defineEmits(['close']);

const confirmAprovar = ref(null);
const confirmDesaprovar = ref(null);

const isLoading = ref(false);
const lsDados = ref([]);
const modoAprovacao = ref(false);
const msgAlerta = ref(null);

const objEdicao = ref(null);
const lsItens = ref([]);
const lsLicitacoes = ref([]);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

function closeForm() { emit('close'); }


async function abrirModalAprovar(){
    const possuiItensSemLicitacao = lsItens.value.some(
        item => !item.aut_idlicitacao
    );

    if (possuiItensSemLicitacao) {
        msgAlerta.value = 'ATENÇÃO: Existem itens sem licitação definida.';
        return;
    }

    const confirmado = await confirmAprovar.value.show({
        message: "Confirma aplicação dos valores e aprovação do orçamento?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){gravarDadosAprovacao()}
}


async function abrirModalDesaprovar(){
    const confirmado = await confirmDesaprovar.value.show({
        message: "Confirma NÃO APROVAÇÃO do orçamento?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){gravarDadosDesaprovacao()}
}


async function baixarAnexo(idanexo) {
    if (!idanexo) {
        msgAlerta.value = 'ATENÇÃO: orçamento sem anexo vinculado.';
        return;
    }
    
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const r = await Api.genericPost('/main/solicitar/download', {id: idanexo});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


async function gravarDadosAprovacao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;

        // SALVAR ÍTENS DO ORÇAMENTO
        for (const item of lsItens.value){
            const payloadItem = {
                id: item.id,
                aut_idlicitacao: item.aut_idlicitacao,
                aut_aldesconto: item.aut_aldesconto,
                aut_vldesconto: item.aut_vldesconto,
                aut_vlautorizado: item.aut_vlautorizado,
                idlogin: globalStore.idlogin}

            const respItem = await Api.genericPut('/cad/manut_os_item', payloadItem);
            if (respItem.bolok != 1) throw new Error(respItem.erro);
        }


        // SALVAR DADOS DO ORÇAMENTO
        const payloadOS = {
            id: objEdicao.value.id,
            aprovacao_idlogin: globalStore.idlogin,
            aprovacao_valor: totalAutorizado.value,
            aprovacao_ok: 'S',
            idlogin: globalStore.idlogin}
        const respOs = await Api.genericPut('/cad/manut_os', payloadOS);
        if (respOs.bolok != 1) throw new Error(respOs?.erro || 'Não foi possível gravar dados da OS');
        modoAprovacao.value=false;
        await lerDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function gravarDadosDesaprovacao(){
    console.log('implementar rotinas desaprovação...');
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 5,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function setAprovacao(obj){
    objEdicao.value = obj;
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idreferencia: obj.id
        };

        const req = await Api.genericPost('/frota/manut_os/itens/orcamento', payload);
        lsItens.value = req || [];

        const reqLic = await Api.genericPost('/frota/licitacoes/ativas', {
            idmunicipio: globalStore.idmunicipio,
            idfornecedor: obj.idfornecedor});
        lsLicitacoes.value = reqLic || [];

        modoAprovacao.value = true;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


//=================================================
// INICIO CÁLCULOS INTERNOS SOBRE OS ÍTENS E TOTAIS
const totalLiquido = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.vlliquido), 0)
);

const totalDesconto = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.aut_vldesconto), 0)
);

const totalAutorizado = computed(() =>
    lsItens.value.reduce((total, item) => total + valorNumber(item.aut_vlautorizado), 0)
);

function valorNumber(valor) {
    return Funcoes.decimalFromString
        ? Funcoes.decimalFromString(valor)
        : Number(valor || 0);
}

function round2(valor) {
    return Math.round((valor + Number.EPSILON) * 100) / 100;
}

function buscarLicitacao(idlicitacao) {
    return lsLicitacoes.value.find(lic => Number(lic.id) === Number(idlicitacao));
}

function aplicarLicitacaoItem(item) {
    const lic = buscarLicitacao(item.aut_idlicitacao);

    if (!lic) {
        item.aut_aldesconto = null;
        item.aut_vldesconto = null;
        item.aut_vlautorizado = valorNumber(item.vlliquido);
        return;
    }

    item.aut_aldesconto = valorNumber(lic.aldesconto);
    recalcularItem(item);
}

function recalcularItem(item) {
    const vlLiquido = valorNumber(item.vlliquido);
    const alDesconto = valorNumber(item.aut_aldesconto);

    const vlDesconto = round2(vlLiquido * alDesconto / 100);
    const vlAutorizado = round2(vlLiquido - vlDesconto);

    item.aut_vldesconto = vlDesconto;
    item.aut_vlautorizado = vlAutorizado;
}
// FIM CÁLCULOS INTERNOS SOBRE OS ÍTENS E TOTAIS
//=================================================


onMounted(lerDados)
</script>
